import { AssemblyLayout } from 'src/components/assemblyLayout';
import { AssemblyScreen } from 'src/components/assemblyScreen';
import { Progress } from 'src/components/progress/Progress';
import { useViewChannelsName } from 'src/hooks';

import { ScreenConfigProps } from './ScreenConfiguration.interface';
import { ScreenContainer, ScreenName } from './ScreenConfiguration.styled';

export const ScreenConfiguration = (props: ScreenConfigProps) => {
  const { data: channelScreenData, isLoading: isLoadingChannelScreens } =
    useViewChannelsName(props?.channelName);

  return (
    <>
      {isLoadingChannelScreens ? (
        <Progress />
      ) : (
        <>
          {channelScreenData && channelScreenData.screens && (
            <ScreenContainer>
              <AssemblyLayout>
                {channelScreenData.screens.map((screen, index) => (
                  <AssemblyScreen
                    key={index}
                    height={screen.height}
                    width={screen.width}
                    scale={
                      props.scale
                        ? props.scale
                        : channelScreenData?.screenConfigurationLabel &&
                          channelScreenData?.screenConfigurationLabel.includes(
                            'horizontal',
                          )
                        ? 0.045
                        : 0.1
                    }
                    selectable={false}
                    type="screen"></AssemblyScreen>
                ))}
              </AssemblyLayout>
              {!props.hideLabel && (
                <ScreenName>
                  {channelScreenData?.screenConfigurationLabel}
                </ScreenName>
              )}
            </ScreenContainer>
          )}
        </>
      )}
    </>
  );
};
